export const EMPTY_STATE_TYPE = {
  DENIED: 'denied',
  DISCONNECT: 'disconnect',
  NOT_FOUND: 'notFound',
};

export const MEDIA_QUERY_TYPE = {
  SMALL_SCREEN: { maxWidth: 1022 },
  MEDIUM_SCREEN: { minWidth: 769, maxWidth: 1023 },
  LARGE_SCREEN: { minWidth: 1024, maxWidth: 1365 },
  EXTRA_LARGE_SCREEN: { minWidth: 1366 },
  SMALL_SCREEN_HERO: { maxWidth: 1023 },
  MEDIUM_SCREEN_HERO: { minWidth: 1023, maxWidth: 1024 },
};

export const URL_IMAGES = {
  FEEDBACK: {
    SUCCESS: 'sellers/feedback/success.svg',
    ERROR: 'sellers/feedback/error.svg',
  },
  HERO: {
    DESKTOP: 'sellers/hero/desktop.svg',
    MOBILE: 'sellers/hero/mobile.svg',
  },
  BOOTS: {
    TOOLS_1: 'sellers/boosts/tools-1.svg',
    TOOLS_2: 'sellers/boosts/tools-2.svg',
    TOOLS_3: 'sellers/boosts/tools-3.svg',
  },
  CONSULT: {
    DESKTOP: 'sellers/consult/desktop.svg',
    MOBILE: 'sellers/consult/mobile-1.svg',
    STEP_1: 'sellers/consult/step-1.svg',
    STEP_2: 'sellers/consult/step-2.svg',
    STEP_3: 'sellers/consult/step-3.svg',
  },
  BENEFITS: {
    DESKTOP: 'sellers/benefits/desktop.svg',
    MOBILE: 'sellers/benefits/mobile.svg',
  },
  SALES: {
    DESKTOP: 'sellers/sales/desktop.svg',
    MOBILE: 'sellers/sales/mobile.svg',
  },
  PLATFORM: {
    DESKTOP: 'sellers/platform/desktop.svg',
    MOBILE: 'sellers/platform/mobile.svg',
  },
  SHARED: {
    DESKTOP: 'sellers/shared-info/desktop.svg',
  },
  TOOLKIT: {
    LEFT: 'sellers/toolkit/left.svg',
    RIGHT: 'sellers/toolkit/right.svg',
  },
};

export const REGEX_VALIDATION = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\d{10,}$/,
};

export const LABEL_TYPE = {
  CHECKBOX: 'checkbox',
};

export const LOGGER_NAME = {
  SAVE_SELLER: 'Fetch save seller - CONTROLLER',
  GET_SEARCH_URL: 'Get search url - CONTROLLER',
};

export const VALIDATION_TYPE = {
  EMAIL: 'email',
  PHONE: 'phone',
};

export const TARGET = {
  SELF: '_self',
  BLANK: '_blank',
  PARENT: '_parent',
  TOP: '_top',
};

export const KEYS = {
  ENTER: 'Enter',
};

export const FAQ_IDS = {
  QUESTION_ONE: 'question-1',
  QUESTION_TWO: 'question-2',
  QUESTION_THREE: 'question-3',
  QUESTION_FOUR: 'question-4',
  QUESTION_FIVE: 'question-5',
  QUESTION_SIX: 'question-6',
};

export const BACKGROUND_TYPE = {
  HERO: 'hero',
  MIDDLE: 'middle',
  ENDING: 'ending',
};

export const BACKGROUND_CURVES_TYPE = {
  CURVE_ZERO: 0,
  CURVE_ONE: 1,
  CURVE_TWO: 2,
  CURVE_THREE: 3,
  CURVE_FOUR: 4,
};

export const HTTP_STATUS_CODES = {
  HTTP_400: 400,
  HTTP_403: 403,
  HTTP_404: 404,
  HTTP_500: 500,
  HTTP_200: 200,
};

export const DEEPLINK_PARAMETERS = {
  BAR_LEFT_BUTTON_STYLE: {
    BACK: 'back',
    CLOSE: 'close',
    NONE: 'none',
  },
  SEARCH_MODE: {
    NONE: 'none',
    EXPANDER: 'expander',
    COLLAPSED: 'collapsed',
  },
  USE_WEB_TITLE: {
    TRUE: true,
    FALSE: false,
  },
  BACK_ACTION: {
    CLOSE: 'close',
    BACK: 'back',
  },
  LOADING_MODE: {
    NONE: 'none',
    SPINNER: 'spinner',
  },
  HIDE_BOTTOM_BAR: {
    TRUE: true,
    FALSE: false,
  },
  BAR_ELEVATION: {
    NONE: 'none',
    DEFAULT: 'default',
  },
  BAR_VISIBILITY: {
    VISIBLE: 'visible',
    GONE: 'gone',
  },
};
